import { v4 as uuidv4 } from 'uuid';
import React, { useState } from 'react';
import TextArea from 'antd/lib/input/TextArea';
import '@ant-design/compatible/assets/index.css';
import { Checkbox, Input, Tabs, Col, Row } from 'antd';
import { Fieldset, Label } from '@iso/containers/Registration/People/SinglePeople.styles.js';
import { displayDateTime, findObjIntoArrayByProp, testEmpty, formatMoney } from '@iso/lib/helpers/utility';

import ordersApi from '@iso/services/repository/order';
import { getProducts } from '../scripts/storeProducts';

export default function CancelSalesModal(props) {

    const [sales, setSales] = useState([]);
    const [updateData, setUpdateData] = useState();
    const [allProducts, setAllProducts] = useState([]);
    const [currentOrderId, setCurrentOrderId] = useState('');
    const [currentSaleItens, setCurrentSaleItens] = useState([]);

    const [checkAll, setCheckAll] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    const [currentCheckedList, setCurrentCheckedList] = useState([]);
    const [currentCheckedListQtds, setCurrentCheckedListQtds] = useState({});
    
    const [activeTabKey, setActiveTabKey] = useState('1');

    React.useEffect(async () => {
        getOrdersFromCashBox(props.id)
        setAllProducts(await getProducts());
    }, [props]);

    const iterateRecords = (data) => {

        let auxSales = [];

        try {
            data.forEach(element => { 

                if(element?.venda) {
                    auxSales.push({
                        'id': element._id,
                        'amount': element.amount,
                        'addition': element.addition,
                        'discount': element.discount,
                        'itens': element.venda?.itens,
                        'usuario': element.venda?.usuario,
                        'cliente': element.venda?.cliente,
                        'paid': element.venda?.payment?.paid,
                        'change': element.venda?.payment?.change,
                        'createdAt': element.venda?.payment?.createdAt
                    })
                }
            });

            setSales(auxSales)
    
        } catch (error) {
            console.log('iterateRecords error: ', error);
        }
    }

    /* TRATANDO LISTA DE VENDA  */
    
    const getOrdersFromCashBox = (id) => {
        ordersApi.getOrdersFromCashBox({cashboxId: id}).then(r => {
            iterateRecords(r.data);
        })
    }

    const changeCurrentOrderId = (e) => {
        try {

            let id = e.target.value;

            setCurrentOrderId(id);

            let idx = findObjIntoArrayByProp(sales, 'id', id);
            if(idx !== -1) {
                let key;
                let idxP;
                let auxItenQtds = {};
                let auxItensOptions = [], auxItenKeys = [];
                sales[idx]['itens'].forEach(item => {
                    idxP = findObjIntoArrayByProp(allProducts, '_id', item.productId);
                    if(idx !== -1) {

                        // key = uuidv4();
                        key = item.key;

                        auxItenKeys.push(key);

                        auxItenQtds[key] = {
                            qtd:item.qtd,
                            id:item.productId
                        }

                        auxItensOptions.push( {
                            ...item,
                            key: key,
                            name:allProducts[idxP]['name']
                        } );
                    }
                });

                setCheckAll(true)
                setCheckedList(auxItenKeys)
                setCurrentCheckedList(auxItenKeys);
                setCurrentSaleItens(auxItensOptions)
                setCurrentCheckedListQtds(auxItenQtds);

                setActiveTabKey('2')

                setUpdateData((prev) => { 
                    prev = {'orderId': id, 'checkedList': auxItenKeys, 'currentCheckedListQtds': auxItenQtds, motive:''};
                    handleUpdateData(prev);
                    return prev 
                });
            }

        } catch (error) { }
    }
 
    const handleTabClick = (e) => {
        setActiveTabKey(e+'')
    }

    /* TRATANDO ITENS DA VENDA  */

    const onCheckAllChange = (e) => {
        setCheckedList(e.target.checked ? currentCheckedList : []);
        setCheckAll(e.target.checked);
    };

    const changeCheckedList = (e) => {
        let auxCheckedList = [...checkedList]
        var index = auxCheckedList.indexOf(e.target.value);
        if (index !== -1) {
            if(!e.target.checked) {
                auxCheckedList.splice(index, 1);
                setCheckAll(false);
            }
        }
        else 
            auxCheckedList.push(e.target.value);

        setCheckedList(auxCheckedList);

        setUpdateData((prev) => { 
            prev['checkedList'] = auxCheckedList;
            handleUpdateData(prev);
            return prev 
        });
    };

    const changeItemQtd = (e) => {
        let auxItenQtds = {...currentCheckedListQtds};
        auxItenQtds[e.target.dataset['key']]['qtd'] = e.target.value;
        setCurrentCheckedListQtds(auxItenQtds);

        setUpdateData((prev) => { 
            prev['currentCheckedListQtds'] = auxItenQtds;
            handleUpdateData(prev);
            return prev 
        });
    }

    const handleUpdateData = (data) => {
        setTimeout(() => {
            props.changeData(data);
        }, 100);
    }

    return (
        <Row gutter={24}>
            <Col span={24}>

                {sales.length > 0 ?
                    <Tabs activeKey={activeTabKey} size="large" onTabClick={handleTabClick}>
                        <Tabs.TabPane tab="Selecione a venda" key="1">
                            {/* <h5>Selecione qual venda deseja cancelar</h5> */}
                            <div style={{padding: '5px 0', overflowY:'scroll'}} className='pdvTable'>
                                <table style={{width:'100%', textAlign:'left', border:'1px #DDD solid', fontSize:'14px', padding:'2px !important'}} border="1px">
                                    <thead>
                                        <tr>
                                            <th style={{width:'50px'}}>&nbsp;</th>
                                            <th>Cliente</th>
                                            <th style={{width:'200px', textAlign:'right'}}>Horário</th>
                                            <th style={{width:'200px', textAlign:'right'}}>Valor total (R$)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sales.map((sale) => {
                                                return  <tr style={{border:'1px #DDD solid', padding: '2px !important'}} key={sale.key}>
                                                            <td>
                                                                <Checkbox checked={currentOrderId === sale.id} value={sale.id} onChange={changeCurrentOrderId}>
                                                                    &nbsp;
                                                                </Checkbox>
                                                            </td>
                                                            <td>{testEmpty(sale.cliente, 'Não informado')}</td>
                                                            <td style={{textAlign:'right'}}>{displayDateTime(sale.createdAt+'')}</td>
                                                            <td style={{textAlign:'right'}}>{formatMoney(sale.amount+'')}</td>
                                                        </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Selecione os itens e conclua o cancelamento" key="2">
                            { currentOrderId !== '' && (
                                <div style={{padding: '5px 0', overflowY:'scroll'}} className='pdvTable'>

                                    <Checkbox onChange={onCheckAllChange} checked={checkAll} style={{width:'100%', textAlign:'left'}}>
                                        Cancelar todos os itens
                                    </Checkbox>

                                    <table style={{width:'100%', marginTop:'10px', textAlign:'left', border:'1px #DDD solid', fontSize:'14px', padding:'2px !important'}} border="1px">
                                        <thead>
                                            <tr>
                                                <th style={{width:'50px'}}>&nbsp;</th>
                                                <th>Produto</th>
                                                <th style={{width: '200px', textAlign:'right'}}>Quantos cancelar?</th>
                                                <th style={{width: '200px', textAlign:'right'}}>Valor unit. (R$)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentSaleItens.map((item) => {
                                                    return  <tr style={{border:'1px #DDD solid', padding: '2px !important'}} key={item.key}>
                                                                <td>
                                                                    <Checkbox checked={checkedList.indexOf(item.key) !== -1} value={item.key} onChange={changeCheckedList}>
                                                                        &nbsp;
                                                                    </Checkbox>
                                                                </td>
                                                                <td>{testEmpty(item.name, 'Sem nome')}</td>
                                                                <td style={{textAlign:'right'}}>
                                                                    <Input type='number' style={{textAlign:'right'}} min={1} max={item.qtd} disabled={item.qtd === '1'} value={currentCheckedListQtds[item.key]['qtd']} data-key={item.key} onChange={changeItemQtd} />
                                                                </td>
                                                                <td style={{textAlign:'right'}}>{formatMoney(item.price+'')}</td>
                                                            </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>

                                    <Fieldset style={{marginTop:'15px'}}>
                                        <Label style={{float:'left', textAlign:'left', fontSize:'14px'}}>Motivo do cancelamento</Label>
                                        <TextArea 
                                            name="motivo"
                                            className='ant-input'
                                            style={{height: '150px', resize:'none'}}
                                            placeholder="Informe o motivo do cancelamento"
                                            onChange={(e) => setUpdateData((prev) => { 
                                                prev['motive'] = e.target.value;
                                                handleUpdateData(prev);
                                                return prev 
                                            })}
                                            >{updateData.motive}</TextArea>
                                    </Fieldset>

                                </div>
                            ) }
                        </Tabs.TabPane>
                    </Tabs>
                    : <>
                        <br/>
                        <div style={{fontSize:'16px'}}>Sem vendas registradas para o caixa atual...</div>
                        <br/>
                    </>
                }
            </Col>
        </Row>
    )
}